import { ref } from 'vue';
import { useServerConfig } from './useServerConfig';
import { useRouter } from 'vue-router';

// Shared state variables
const llcs = ref([]);
const assets = ref([]);
const members = ref([]);
const renewals = ref([]);
const error = ref('');

export function useGetUserInfo() {
  const { serverAddress } = useServerConfig();
  const router = useRouter();

  const getUserInfo = async () => {
    try {
      const response = await fetch(`${serverAddress.value}/resources/getuserinfo`, {
        credentials: 'include',
        method: 'POST',
      });

      if (!response.ok) {
        throw response.status;
      }

      const data = await response.json();
      if (!data.success) throw data.error;

      llcs.value = data.llcs;
      assets.value = data.assets;
      members.value = data.members;
      renewals.value = data.renewals;

      return true;
    } catch (err) {
      console.error('Error in getUserInfo:', err);
      if (err === 401) {
        router.push({ name: 'login' });
      } else {
        error.value = 'There was an error getting your account information. Please try refreshing the page.';
      }
      return false;
    }
  };

  return {
    llcs,
    assets,
    members,
    renewals,
    error,
    getUserInfo,
  };
}
